import { createPinia } from 'pinia'
import persistedState from 'pinia-plugin-persistedstate'

export default function createPiniaRoot() {
    const pinia = createPinia()
    pinia.use(persistedState)
    return pinia
}